import React, { useRef } from "react";

import * as S from "./styles";

export const Slide3: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <S.Container>
      <S.Credit>
        Blazer, NK Store, R$ 3.791. Calça, Printing, R$ 1.127.
      </S.Credit>
      <S.Video>
        <video ref={videoRef} muted autoPlay loop playsInline>
          <source
            src="https://player.vimeo.com/external/538845664.hd.mp4?s=7448cbc76fc69fc09d1d20c785c1dd72a4c1e0ba&profile_id=175&download=1"
            type="video/mp4"
          />
        </video>
      </S.Video>
    </S.Container>
  );
};
